import { render } from "./PalliativeProfessionalProfile.vue?vue&type=template&id=63470ab4&scoped=true"
import script from "./PalliativeProfessionalProfile.vue?vue&type=script&lang=js"
export * from "./PalliativeProfessionalProfile.vue?vue&type=script&lang=js"

import "./PalliativeProfessionalProfile.vue?vue&type=style&index=0&id=63470ab4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63470ab4"]])

export default __exports__